import { createRouter, createWebHistory } from 'vue-router'
import store from './store'

// Import page components
import SalesPage from './views/SalesPage.vue'
import HomePage from './views/HomePage.vue'
import CheatSheetPage from './views/CheatSheetPage.vue'
import ChallengeCalendarPage from './views/ChallengeCalendarPage.vue'
import TroubleshootingPage from './views/TroubleshootingPage.vue'
import SetupScriptsPage from './views/SetupScriptsPage.vue'
import ProgressPage from './views/ProgressPage.vue'
import AdminDashboard from './views/AdminDashboard.vue'

const routes = [
  {
    path: '/',
    name: 'Root',
    component: SalesPage,
    beforeEnter: (to, from, next) => {
      // If user has a valid API key, redirect to home
      if (store.state.apiKey && store.state.isValidApiKey) {
        next('/home')
      } else {
        next()
      }
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/cheatsheet',
    name: 'CheatSheet',
    component: CheatSheetPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/challenges',
    name: 'Challenges',
    component: ChallengeCalendarPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/troubleshooting',
    name: 'Troubleshooting',
    component: TroubleshootingPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/setup',
    name: 'SetupScripts',
    component: SetupScriptsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/progress',
    name: 'Progress',
    component: ProgressPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: false } // Admin has its own auth
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Always scroll to top when navigating
    return { top: 0 }
  }
})

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user has valid API key
    if (!store.state.apiKey || !store.state.isValidApiKey) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router